var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { transient, autoinject } from 'aurelia-dependency-injection';
import { PLATFORM } from 'aurelia-pal';
import { Router } from 'aurelia-router';
import { I18N } from 'aurelia-i18n';
import { BindingSignaler } from 'aurelia-templating-resources';
import { BaseLobby } from '../../templates/base-lobby';
import { TokenClient } from '../../../../services/authentication/token-client.service';
import { ClientLotteryClientService } from '../../../../services/modules/client/client-lottery-client-service';
import { NotificationClientService } from '../../../../services/basics/notification-client.service';
import { DialogClientService } from '../../../../services/basics/dialog-client.service';
import { ConfigClientService } from '../../../../services/modules/client-config.service';
import { RoutingHelper } from '../../../../helpers/routing.helper';
var RenderLobby = /** @class */ (function (_super) {
    __extends(RenderLobby, _super);
    function RenderLobby(lotteryClientService, router, tokenClient, i18n, notificationClientService, dialogClientService, configClientService, routingHelper, bindingSignaler) {
        var _this = _super.call(this, lotteryClientService, router, tokenClient, i18n, notificationClientService, dialogClientService, configClientService, routingHelper, bindingSignaler) || this;
        _this.sections = [];
        return _this;
    }
    RenderLobby_1 = RenderLobby;
    RenderLobby.prototype.activate = function (params) {
        this.loadSections();
        return _super.prototype.activate.call(this, params);
    };
    RenderLobby.prototype.loadSections = function () {
        var _this = this;
        try {
            var server = window.server;
            var layout = server && server.renderLayout ? server.renderLayout : null;
            var lobby = layout && layout.lobby ? layout.lobby : null;
            if (lobby && lobby.length) {
                this.sections = lobby
                    .filter(function (s) { return s.visible !== false; })
                    .map(function (s) { return _this.prepareRow(s); })
                    .filter(function (s) { return _this.isRow(s) ? s.children.length > 0 : !!_this.blockModule(s); })
                    .sort(function (a, b) { return (a.order || 0) - (b.order || 0); });
            }
        }
        catch (_a) {
            this.sections = [];
        }
    };
    RenderLobby.prototype.isRow = function (section) {
        return !!section && section.type === 'Row';
    };
    /** For a Row, keep only visible children that resolve to a block; leaf sections pass through. */
    RenderLobby.prototype.prepareRow = function (section) {
        var _this = this;
        if (this.isRow(section)) {
            section.children = (section.children || []).filter(function (c) { return c.visible !== false && !!_this.blockModule(c); });
        }
        return section;
    };
    Object.defineProperty(RenderLobby.prototype, "shell", {
        /** The shell itself - bound as each block's `host` (resolves at the root scope, even inside a Row repeat). */
        get: function () {
            return this;
        },
        enumerable: false,
        configurable: true
    });
    RenderLobby.prototype.blockModule = function (section) {
        if (!section) {
            return null;
        }
        var variant = section.variant || RenderLobby_1.defaultVariantForType[section.type];
        return variant ? RenderLobby_1.variantModules[variant] : null;
    };
    /** Bundle card background: each bundle's own image, keyed per-bundle (edited in the bundle dialog). */
    RenderLobby.prototype.getBundlesBackground = function (bundle) {
        return this.i18n.tr(this.getBundleKey(bundle.name) + '-lobby-card-background');
    };
    var RenderLobby_1;
    RenderLobby.variantModules = {
        'fold-t7': PLATFORM.moduleName('app/styles/client/render-engine/blocks/fold/fold'),
        'advert-t7': PLATFORM.moduleName('app/styles/client/render-engine/blocks/advert/advert'),
        'stories-t7': PLATFORM.moduleName('app/styles/client/render-engine/blocks/stories/stories'),
        'lotteries-carousel-t7': PLATFORM.moduleName('app/styles/client/render-engine/blocks/lotteries-carousel/lotteries-carousel'),
        'scratch-cards-carousel-t7': PLATFORM.moduleName('app/styles/client/render-engine/blocks/scratch-cards-carousel/scratch-cards-carousel'),
        'banners-t7': PLATFORM.moduleName('app/styles/client/render-engine/blocks/banners/banners'),
        'lotteries-grid-t7': PLATFORM.moduleName('app/styles/client/render-engine/blocks/lotteries-grid/lotteries-grid'),
        'instant-game-cards-t7': PLATFORM.moduleName('app/styles/client/render-engine/blocks/instant-game-cards/instant-game-cards'),
        'bundles-t7': PLATFORM.moduleName('app/styles/client/render-engine/blocks/bundles/bundles'),
        'instant-games-t7': PLATFORM.moduleName('app/styles/client/render-engine/blocks/instant-games/instant-games'),
        'latest-results-t7': PLATFORM.moduleName('app/styles/client/render-engine/blocks/latest-results/latest-results'),
        'banners-t3': PLATFORM.moduleName('app/styles/client/render-engine/blocks/banners-t3/banners-t3'),
        'latest-results-t3': PLATFORM.moduleName('app/styles/client/render-engine/blocks/latest-results-t3/latest-results-t3'),
        'how-to-play-t3': PLATFORM.moduleName('app/styles/client/render-engine/blocks/how-to-play-t3/how-to-play-t3'),
        'lotteries-grid-t9': PLATFORM.moduleName('app/styles/client/render-engine/blocks/lotteries-grid-t9/lotteries-grid-t9'),
        'fold-t1': PLATFORM.moduleName('app/styles/client/render-engine/blocks/fold-t1/fold-t1'),
        'banners-t1': PLATFORM.moduleName('app/styles/client/render-engine/blocks/banners-t1/banners-t1'),
        'lotteries-grid-t1': PLATFORM.moduleName('app/styles/client/render-engine/blocks/lotteries-grid-t1/lotteries-grid-t1'),
        'latest-results-t1': PLATFORM.moduleName('app/styles/client/render-engine/blocks/latest-results-t1/latest-results-t1'),
        'lotteries-grid-t10': PLATFORM.moduleName('app/styles/client/render-engine/blocks/lotteries-grid-t10/lotteries-grid-t10'),
        'banners-custom': PLATFORM.moduleName('app/styles/client/render-engine/blocks/banners-custom/banners-custom'),
    };
    RenderLobby.defaultVariantForType = {
        Fold: 'fold-t7',
        Advert: 'advert-t7',
        Stories: 'stories-t7',
        LotteriesCarousel: 'lotteries-carousel-t7',
        ScratchCardsCarousel: 'scratch-cards-carousel-t7',
        Banners: 'banners-t7',
        LotteriesGrid: 'lotteries-grid-t7',
        InstantGameCards: 'instant-game-cards-t7',
        Bundles: 'bundles-t7',
        InstantGames: 'instant-games-t7',
        LatestResults: 'latest-results-t7',
    };
    RenderLobby = RenderLobby_1 = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [ClientLotteryClientService, Router, TokenClient, I18N,
            NotificationClientService, DialogClientService,
            ConfigClientService, RoutingHelper, BindingSignaler])
    ], RenderLobby);
    return RenderLobby;
}(BaseLobby));
export { RenderLobby };
